export type ParsedAttribute = {name: string; value: string};

/**
 * Parses one pasted `name=value` custom attribute. The caller keeps existing
 * behavior when there is no complete pair to split.
 */
export const parseAttributePaste = (input: string): ParsedAttribute | null => {
  const equalsIndex = input.indexOf('=');
  if (equalsIndex === -1) {
    return null;
  }

  const name = input.slice(0, equalsIndex).trim();
  let value = input.slice(equalsIndex + 1).trim();

  if (value.length >= 2) {
    const first = value[0];
    const last = value[value.length - 1];
    if ((first === '"' && last === '"') || (first === "'" && last === "'")) {
      value = value.slice(1, -1);
    }
  }

  if (!name || !value) {
    return null;
  }

  return {name, value};
};
